module.exports = __webpack_public_path__ + "img/custom.47a29c5b.svg";